import type { FC } from "react";
import { Link } from "expo-router";
import { Card } from "@ptsd/uikit";
import { Text, YStack } from "tamagui";

import { api } from "~/utils/api";

interface PersonGeneralProps {
  personId: string;
}
export const PersonGeneral: FC<PersonGeneralProps> = ({ personId }) => {
  const [data] = api.personal.info.useSuspenseQuery({ personId });

  return (
    <Card padding={"$3"}>
      <YStack gap={"$1"} justifyContent="center" alignItems="flex-start">
        <Text fontFamily={"$heading"} fontWeight={"$6"} fontSize={"$7"}>
          {data.name}
        </Text>
        <Link href={`mailto:${data.email}`}>
          <Text fontFamily={"$heading"} fontSize={"$6"} color={"$gray-600"}>
            {data.email}
          </Text>
        </Link>
        <Link href={`tel:${data.phone}`}>
          <Text fontFamily={"$heading"} fontSize={"$6"} color={"$gray-600"}>
            {data.phone}
          </Text>
        </Link>
      </YStack>
    </Card>
  );
};
